module.exports = __webpack_public_path__ + "img/tasmota-wifi-app.8e7923c1.png";